import React from 'react';
import { StartDateInput } from 'src/components/oneCorp/features/MealCredit/common/formFields/DateInput/StartDateInput';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';

export function StartDateInputWrapper(): JSX.Element {
  const { isEditing } = useMealCreditFormData();

  return <StartDateInput id="date" name="date" disabled={isEditing} />;
}
